import {GroupCondition} from './group-condition';
import {GroupType} from './group-type';
import {GroupVersion} from './auto-group/auto-group-setting';

export class InfluencerGroup {
  influencer_group_id: number | null;
  influencer_group_name: string | null;
  influencer_group_description: string | null;
  identify_relevant_influencers: boolean | null;
  companyId: number | null;
  influencer_group_type: number | null;
  influencer_group_type_values: GroupType[] = [];
  influencer_group_type_id: number;
  menuvisible: number | null;
  condition_list_object: GroupCondition[] = [];
  number_of_influencer: number | null;
  influencers: Array<any>;
  total_reach: number | null;
  total_engagement: number | null;
  version: GroupVersion;
  status: string;
}

export class InfluencerGroups {
  id: number;
  name: string;
  description: string | null;
  type: {
    id: number;
    type: string;
    description: string;
  };
  companyId: number;
  createdAt: Date;
  modifiedAt: Date;
  totalInfluencers: number;
  totalReach: number;
  totalEngagement: number;
  menuVisible: boolean;
  totalFollowers: number;
  totalImpact: number;
  totalImpression: number;
  totalPosts: number;
  influencers: Array<any>;
  totalPendingInfluencers: number;
}

export class InfluencerGroupNew {
  influencerGroupId: number | null;
  influencerGroupName: string | null;
  influencerGroupType: number | null;
  influencerGroupDescription: string;
  companyId: number | null;
  menuvisible: number | null;
}

export class BulkUploadInfluencer {
  influencers: BulkUploadInfluencerDetail[] = [];
  shouldNotify: boolean;
}

export class BulkUploadInfluencerDetail {
  handle: string;
  platform: string;
}



// WEBPACK FOOTER //
// ./src/models/influencer-group.ts